"use client";

import { ArrowLeftEndOnRectangleIcon } from "@heroicons/react/16/solid";
import {
  Cog6ToothIcon,
  HomeIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/20/solid";

import Logo from "@/assets/logo.svg?react";

import { Link } from "@/components/clickable";
import { HStack, VStack } from "@/components/layout";
import ProgressBar from "@/components/progress-bar";
import { showCustomerService } from "@/components/vendors";
import { useAuthContext } from "@/modules/auth";
import { cx } from "@/utils";
import SidebarBody from "./body";
import SidebarFooter from "./footer";
import SidebarHeader from "./header";
import SidebarItem from "./item";
import SidebarLabel from "./label";
import SidebarSection from "./section";
import SidebarSpacer from "./spacer";

export default function Sidebar({ className, ...props }) {
  const { signOut } = useAuthContext();

  return (
    <nav {...props} className={cx("flex h-full min-h-0 flex-col", className)}>
      <SidebarHeader className="border-none">
        <Link href="/">
          <Logo />
        </Link>
      </SidebarHeader>

      <SidebarBody>
        <SidebarSection>
          <SidebarItem href="/">
            <HomeIcon />
            <SidebarLabel className="font-normal">Projects</SidebarLabel>
          </SidebarItem>
          <SidebarItem href="/settings" className="hidden">
            <Cog6ToothIcon />
            <SidebarLabel className="font-normal">Settings</SidebarLabel>
          </SidebarItem>
        </SidebarSection>

        <SidebarSpacer />

        <SidebarSection>
          <SidebarItem onClick={showCustomerService}>
            <QuestionMarkCircleIcon />
            <SidebarLabel className="font-normal">Get help</SidebarLabel>
          </SidebarItem>
          <SidebarItem onClick={signOut}>
            <ArrowLeftEndOnRectangleIcon />
            <SidebarLabel className="font-normal">Log out</SidebarLabel>
          </SidebarItem>
        </SidebarSection>
      </SidebarBody>

      <SidebarFooter className="border-none max-lg:hidden">
        <VStack className="hidden">
          <p className="text-cp-grey-700 text-xs font-medium">Your plan</p>
          <p className="text-base font-semibold">Growth</p>
          <VStack className="w-full gap-1">
            <ProgressBar progress={80} />
            <HStack className="w-full justify-between">
              <p className="text-cp-grey-700 text-xs">869 pages remaining</p>
              <Link href="#" className="text-xs font-medium underline">
                Need more?
              </Link>
            </HStack>
          </VStack>
        </VStack>
      </SidebarFooter>
    </nav>
  );
}
